export default "__VITE_ASSET__34b2f366__"